export default "__VITE_PUBLIC_ASSET__91375807__"